export const FILE_TYPE_FILE = 1;
export const FILE_TYPE_LINK = 2;
export const FILE_TYPE_TO_CONVERT = 3;